import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import IvrGuruIntegration from "./IvrGuruIntegration";
import WebhookIntegrations from "./WebhookIntegrations";


const TABS = [
  { id: "ivrguru", label: "IVR GURU" },
  { id: "webhooks", label: "Webhook Integrations" },
];

const IvrIntegration = () => {
  // Session storage logic for tab persistence
  const [activeTab, setActiveTab] = useState(() => {
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('ivrIntegrationActiveTab') || "ivrguru";
    }
    return "ivrguru";
  });

  // Save active tab state whenever it changes
  useEffect(() => {
    sessionStorage.setItem('ivrIntegrationActiveTab', activeTab);
  }, [activeTab]);

  return (
    <div className="mx-auto bg-[#FAF8FF] dark:bg-gray-900 p-6 rounded-xl shadow-sm transition-all duration-200 relative cfg-font">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
      <div className="mb-6">
        <h2 className="text-2xl font-bold bg-gradient-to-r from-[#8B5CF6] to-[#673AB7] bg-clip-text text-transparent mb-4" style={{ fontFamily: "'Sora', sans-serif" }}>
          Call Integrations
        </h2>

        <div className="flex gap-1 border-b border-gray-200 dark:border-gray-700">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
                activeTab === tab.id
                  ? "border-[#673AB7] text-[#673AB7]"
                  : "border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === "ivrguru" ? <IvrGuruIntegration /> : <WebhookIntegrations />}
    </div>
  );
};

export default IvrIntegration;
